module.exports = __webpack_public_path__ + "img/selfie-credit.46c06cf9.svg";